import '../layout/theme';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Competition } from './components/stack/views/Competition/Competition';
import { CompetitionPropsProvider } from './components/stack/hooks/content/useCompetitionProps';
import { BaseContentProvider } from './components/stack/components/BaseContentProvider/BaseContentProvider';
import { DefaultLayout, drawDefaultLayout } from './components/layout/DefaultLayout';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('content-hub');
  if (!container) return drawDefaultLayout();
  const root = createRoot(container);

  root.render(
    <BaseContentProvider>
      <CompetitionPropsProvider>
        <DefaultLayout>
          <Competition />
        </DefaultLayout>
      </CompetitionPropsProvider>
    </BaseContentProvider>
  );
});
